<div class="header">
  <div class="-left-side">
    <div class="-logo-container">
      <a [routerLink]="'/'">
        <site-logo [type]="'global'"></site-logo>
      </a>
    </div>
    <div class="-main-nav-container" *ngIf="showNavMenu">
      <app-header-nav [menu]="menu"></app-header-nav>
    </div>
  </div>
  <div class="-right-side">
    <div class="quick-links-container-lg-screen">
      <span class="-search-container">
        <!-- <search-form (expandedChange)="onSearchExpand($event)"></search-form> -->
         <app-devsite-search (expandedChange)="onSearchExpand($event)"></app-devsite-search>
      </span>
      <div class="quick-links -announcement">
        <span class="-announcement-link">
          <lucide-icon name="bell"></lucide-icon>
        </span>
        <span class="dark-mode-toggle">
          <a (click)="switchThemeMode()">
            <lucide-icon [name]="theme === 'light' ? 'moon' : 'sun'"></lucide-icon>
          </a>
        </span>
        <span *ngIf="supportMenu" class="support">
          <app-link [to]="supportMenu.path"><lucide-icon [name]="supportMenu.icon"></lucide-icon></app-link>
          <ng-container *ngIf="supportMenu.children && supportMenu.children.length > 0">
            <menu-dropdown [dropdownTo]="supportMenu.children"></menu-dropdown>
          </ng-container>
        </span>
        <span class="user-info" *ngIf="isUserLoggedIn" (mouseenter)="onUserInfoMouseEnter()" (mouseleave)="onUserInfoMouseLeave()">
          <lucide-icon name="circle-user-round"></lucide-icon>
          <user-account-dropdown *ngIf="isDropdownVisible" [title]="userName" [subtitle]="userMail"></user-account-dropdown>
        </span>
      </div>
      <span class="user-login" *ngIf="!isUserLoggedIn">
        <wpbutton to="/account/login">Login</wpbutton>
      </span>
    </div>
    <div class="-small-screen-hamburger-menu">
      <lucide-icon name="menu" *ngIf="!isResponsiveNav" (click)="toggleResponsiveMenu()"></lucide-icon>
      <lucide-icon id="closeHamburger" name="x" *ngIf="isResponsiveNav" (click)="toggleResponsiveMenu()"></lucide-icon>
    </div>
  </div>
</div>
<div *ngIf="!isResponsiveNav && metadata && metadata.template && (metadata.template === 'prod-doc-page' || metadata.template === 'product-landing' || metadata.template === 'contact-sales' || metadata.template === 'doc-page' || (metadata.template === 'redoc' && metadata['secondary-nav'] ) || (metadata.template === 'sdk' && metadata['secondary-nav'] )) && (metadata['sec-nav'] === undefined ? true : metadata['sec-nav'])">
  <docheader-secondary-nav></docheader-secondary-nav>
</div>
<div class="-nav-container-responsive" *ngIf="isResponsiveNav">
  <ng-container *ngIf="isSidebarPresent; else navContainerTemplate">
    <app-sidebar
    [menu]="sidebarMetadata"
    [globalNav]="menu"
    [userName]="userName"
    [userMail]="userMail"
    [isUserLoggedIn]="isUserLoggedIn"
    ></app-sidebar>
  </ng-container>
  <ng-template #navContainerTemplate>
    <app-nav-container
     [menu]="menu"
     [supportMenu]="supportMenu"
     [userName]="userName"
     [userMail]="userMail"
     [isUserLoggedIn]="isUserLoggedIn"
     ></app-nav-container>
  </ng-template>
</div>
